/**
 * Created by Mikhail Menshenin on 23.08.2024
 */

class VillageRaidSceneComponent extends VillageSceneComponent {
    onCreate() {
        super.onCreate();

        if (!this.args.snapshotLoaded) {
            this.village.prepareToRaid();
        }
        this.player = this.village.getPlayer();
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        cleverapps.audio.playSound(bundles.game.urls.slot_next_scene);

        this.village.counter.registerStage(10, () => {
            if (this.village.isRaidFinished()) {
                this.showStealPanel();
            }
        });

        this.village.on("goldDigged", this.showGoldDigged.bind(this), this.node);

        this.village.counter.trigger();
    }

    addUI() {
        const styles = cleverapps.styles.VillageRaidScene;

        const controlPanel = this.controlPanel = new RaidControlPanelView(this.village, this.player);
        controlPanel.setAlignment(styles.control);
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            cleverapps.UI.fitToBox(controlPanel, styles.control);
        }
        this.node.addChild(controlPanel);
        controlPanel.showRaidScene();

        const raidsView = new RaidsView(this.village);
        raidsView.setAlignment(styles.raids.position);
        raidsView.setScale(styles.raids.scale[cleverapps.resolution.mode]);
        this.node.addChild(raidsView);
    }

    showStealPanel() {
        const styles = cleverapps.styles.VillageRaidScene;

        const stealPanel = this.stealPanel = new RaidStealPanelView(this.village, this.player);
        stealPanel.setAlignment(styles.steal);
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            cleverapps.UI.fitToBox(stealPanel, styles.steal);
        }
        this.node.addChild(stealPanel, 5);
        stealPanel.setVisible(false);

        if (this.village.perfectRaid) {
            cleverapps.audio.playSound(bundles.main.urls.perfect);
            cleverapps.exclamation.show("Perfect Raid", Exclamation.Types.Firework);
        }

        this.controlPanel.runAction(new cc.Sequence(
            new cc.DelayTime(this.village.perfectRaid ? 0.5 : 0),
            new cc.CallFunc(() => {
                this.controlPanel.hide();
                stealPanel.show();

                const button = this.tapToContinue = new TapToContinue({
                    text: "Window.TapToContinue"
                });
                button.setAlignment(styles.tapToContinue);
                this.node.addChild(button, 5);
                button.show();

                cleverapps.UI.onClick(this.node, this.hideStealPanel.bind(this), {
                    interactiveScale: false
                });
            })
        ));
    }

    hideStealPanel() {
        this.stealPanel.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.CallFunc(() => {
                this.tapToContinue.hide();
            }),
            new cc.MoveBy(0.4, 0, -this.stealPanel.height).easing(cc.easeOut(3)),
            new cc.CallFunc(this.finish.bind(this))
        ));
    }

    showGoldDigged(gold, cb) {
        const styles = cleverapps.styles.VillageRaidScene;

        if (gold === 0) {
            cleverapps.audio.playSound(bundles.main.urls.nocoins);
            cleverapps.exclamation.show("no coins", Exclamation.Types.No_firework, cb);
            return;
        }

        cleverapps.audio.playSound(bundles.main.urls.winnings);

        const goldRaidedText = cleverapps.UI.generateOnlyText(aisensia.getNumberWithCommas(gold), cleverapps.styles.FONTS.RAID_REWARD_TEXT);
        goldRaidedText.setAlignment(styles.raidedText);
        this.node.addChild(goldRaidedText);
        goldRaidedText.setScale(0);

        const goldTextBg = new cc.Sprite(bundles.village.frames.numbers_bg);
        goldTextBg.setAlignment(styles.raidedText.bg);
        cleverapps.UI.fitToBox(goldTextBg, styles.raidedText.bg);
        goldRaidedText.addChild(goldTextBg, -1);

        goldRaidedText.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1),
            new cc.DelayTime(0.4),
            new cc.CallFunc(cb || (() => {})),
            StandartAnimations.animateCollect(goldRaidedText, "earnedText", {
                duration: 0.2,
                adjustToTarget: true,
                jump: true
            }),
            new cc.Hide()
        ));
    }

    listBundles() {
        return super.listBundles().concat(["transition_raid"]);
    }
}

Prefab.registerComponent("VillageRaidSceneComponent", VillageRaidSceneComponent);

cleverapps.Environment.SCENE_VILLAGE_RAID = "villageRaid";

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RAID_REWARD_TEXT: {
        size: 100,
        color: new cc.Color(254, 187, 15, 255),
        stroke: {
            color: new cc.Color(139, 56, 2, 255),
            size: 3
        }
    },
    RAID_EXCLAMATION_TEXT: {
        size: 110,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(138, 52, 34, 255),
            size: 3
        }
    }
});

cleverapps.styles.VillageRaidScene = {
    control: {
        width: 540,
        height: 260,

        x: { align: "center", dx: -3 },
        y: { align: "top", dy: 40 }
    },

    steal: {
        width: 540,
        height: 260,

        x: { align: "center", dx: -3 },
        y: { align: "bottom", dy: -60 }
    },

    raids: {
        scale: [0.9, 1.15, 1.15],
        position: [{
            x: { align: "left", dx: 56 },
            y: { align: "bottom", dy: 40 }
        }, {
            x: { align: "left", dx: 78 },
            y: { align: "bottom", dy: 66 }
        }, {
            x: { align: "left", dx: 78 },
            y: { align: "bottom", dy: 66 }
        }]
    },

    raidedText: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 },
        bg: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 },
            width: 350,
            height: 250
        }
    },

    tapToContinue: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 250 }
    }
};
